import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  getInProgressLongTermApi,
  getInProgressShortTermApi,
  getInterventionInProgressLongTermApi,
  getInterventionInProgressShortTermApi,
} from '../../../api/services/Intervention/allInprogressGoals';

const initialState = {
  inProgressLongTerm: [],
  inProgressShortTerm: [],
  error: false,
  loading: false,
};

interface Payload {
  providerId: string;
  clientId: string;
  childPayerId: any;
}
interface InterventionPayload {
  clientId: string;
  organizationServiceId: any;
}

export const callLongInProgressGoals = createAsyncThunk(
  'callLongInProgressGoals',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const res = await getInProgressLongTermApi.getLongTermGoal(payload);
      return res.data.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const callShortInProgressGoals = createAsyncThunk(
  'callShortInProgressGoals',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const res = await getInProgressShortTermApi.getShortTermGoal(payload);
      return res.data.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const callInterventionLongInProgressGoals = createAsyncThunk(
  'callInterventionLongInProgressGoals',
  async (payload: InterventionPayload, { rejectWithValue }) => {
    try {
      const res = await getInterventionInProgressLongTermApi.getLongTermGoal(payload);
      return res.data.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const callInterventionShortInProgressGoals = createAsyncThunk(
  'callInterventionShortInProgressGoals',
  async (payload: InterventionPayload, { rejectWithValue }) => {
    try {
      const res = await getInterventionInProgressShortTermApi.getShortTermGoal(payload);
      return res.data.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
const allInProgressGoals = createSlice({
  name: 'allInProgressGoals',
  initialState,
  reducers: {
    setAllDataOfShortTerm: (state: any, action: any) => {
      state.inProgressShortTerm = action.payload;
    },
    clearLongTermShortTerm: (state: any) => {
      state.inProgressShortTerm = [];
      state.inProgressLongTerm = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(callLongInProgressGoals.pending, state => {
        state.loading = true;
      })
      .addCase(callLongInProgressGoals.fulfilled, (state: any, action) => {
        state.inProgressLongTerm = action.payload;
        state.loading = false;
      })
      .addCase(callLongInProgressGoals.rejected, state => {
        state.error = true;
        state.loading = false;
      })
      .addCase(callShortInProgressGoals.pending, state => {
        state.loading = true;
      })
      .addCase(callShortInProgressGoals.fulfilled, (state: any, action) => {
        state.inProgressShortTerm = action.payload;
        state.loading = false;
      })
      .addCase(callShortInProgressGoals.rejected, state => {
        state.error = true;
        state.loading = false;
      })
      .addCase(callInterventionShortInProgressGoals.pending, state => {
        state.loading = true;
      })
      .addCase(callInterventionShortInProgressGoals.fulfilled, (state: any, action) => {
        state.inProgressShortTerm = action.payload;
        state.loading = false;
      })
      .addCase(callInterventionShortInProgressGoals.rejected, state => {
        state.error = true;
        state.loading = false;
      })
      .addCase(callInterventionLongInProgressGoals.pending, state => {
        state.loading = true;
      })
      .addCase(callInterventionLongInProgressGoals.fulfilled, (state: any, action) => {
        state.inProgressLongTerm = action.payload;
        state.loading = false;
      })
      .addCase(callInterventionLongInProgressGoals.rejected, state => {
        state.error = true;
        state.loading = false;
      });
  },
});
export const { setAllDataOfShortTerm, clearLongTermShortTerm } = allInProgressGoals.actions;

export default allInProgressGoals.reducer;
